import React from "react";
import ChatBot from "./components/ChatBot";

function App() {
  return <ChatBot />;
}

export default App;
